import {NgModule} from '@angular/core';

import {SharedModule} from '../shared/shared.module';

import {
  IamTableComponent,
  IamPeriodComponent,
  CountyGeoComponent,
  TaxAuthorityComponent,
  AttachmentViewerComponent,
  SigningComponent
} from './components/entity';
import {LoadingSpinnerComponent} from './components/entity/signing/loading-spinner.component';

@NgModule({
  declarations: [
    IamTableComponent,
    IamPeriodComponent,
    CountyGeoComponent,
    TaxAuthorityComponent,
    AttachmentViewerComponent,
    SigningComponent,
    LoadingSpinnerComponent
  ],
  imports: [
    SharedModule
  ],
  exports: [
    SharedModule,
    IamTableComponent,
    IamPeriodComponent,
    CountyGeoComponent,
    TaxAuthorityComponent,
    AttachmentViewerComponent,
    SigningComponent
  ]
})
export class EntitiesModule {
}
